import * as Sentry from '@sentry/react';
import React from 'react';
import { Box } from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import { FormattedMessage } from 'react-intl';
import ErrorIllustration from './illustrations/ErrorIllustration';
import { messages } from './messages';
import { useReportUFOError } from '../analytics/react-ufo';

const errorStyles = xcss({
	marginTop: 'space.800',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	rowGap: 'space.150',
});

const errorHeaderStyles = xcss({
	font: 'font.heading.medium',
	fontWeight: 'font.weight.medium',
});

const errorSubheaderStyles = xcss({
	font: 'font.body',
});

const defaultFallback = (
	<Box testId="default-error" xcss={errorStyles}>
		<ErrorIllustration />
		<Box xcss={errorHeaderStyles}>
			<FormattedMessage {...messages.errorHeader} />
		</Box>
		<Box xcss={errorSubheaderStyles}>
			<FormattedMessage {...messages.errorBoundarySubheader} />
		</Box>
	</Box>
);

export const ErrorBoundary = ({
	children,
	fallback,
}: {
	children: React.ReactNode;
	fallback?: React.JSX.Element;
}): React.JSX.Element => {
	const reportUFOError = useReportUFOError();

	return (
		<Sentry.ErrorBoundary fallback={fallback ?? defaultFallback} onError={reportUFOError}>
			{children}
		</Sentry.ErrorBoundary>
	);
};
